export enum ProductVisibilityEnum {
  Visible = 0, // Will be visible when activated
  NotVisible = 1, // Will not be visible when activated
}
